import {endpoints} from './endpoints'
import request from '../../request'

export function getProjectChatRooms(params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getProjectChatRooms,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getRoomMessages(params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getRoomMessages,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function sendRoomMessage(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.sendRoomMessage,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}